export const locale = {
    lang: 'en',
    data: {
        CUSTOMER_TOOLBAR: {
            TITLES: {
                CUSTOMERS: 'Customers',
                PORTFOLIO: 'Portfolio',
                OPEN_PROFILE: 'Open profile',
                SEARCH_CUSTOMERS: 'Search customers',
                CLEAR_SEARCH: 'Clear search',
                CLEAR_SELECTION: 'Clear selection',
                HOT_PROSPECTS: 'Hot Prospects',
                ALL_CUSTOMERS: 'All Customers',
                VIEW_ALL_CUSTOMERS: 'View all customers',
                NO_CUSTOMERS: 'No Customers',
                NO_CUSTOMERS_FOUND: 'No Customers Found',
                NO_CUSTOMER_SEARCH_RESULT: '"{{text}}" did not match any customers.',
                PLEASE_TRY_AGAIN_OR: 'Please try again or ',
                ADD_CUSTOMER: 'add customer',
                ADD_CUSTOMER_TITLE: 'Add customer',
                ADD_YOUR_FIRST_CUSTOMER: 'Add your first customer by clicking below.'
            },
        }
    }
};